import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StarRating } from "../star-rating";
import { Author } from "../author";
import { Media } from "../media";
import styles from "./intro.module.css";
import sharedStyles from "../../car-reviews-v2.module.css";
export const Intro = ({ contentTitle , contentStarRating , contentIntroText , authorImage , authorName , imageCount , introImage , latestPublishDate , video  })=>/*#__PURE__*/ _jsxs("div", {
        className: sharedStyles.inner,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.heading,
                children: contentTitle
            }),
            /*#__PURE__*/ _jsx(StarRating, {
                starRating: Number(contentStarRating)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: sharedStyles.reviewCopy,
                children: contentIntroText
            }),
            /*#__PURE__*/ _jsx(Author, {
                name: authorName,
                image: authorImage,
                latestPublishDate: latestPublishDate
            }),
            /*#__PURE__*/ _jsx(Media, {
                imageCount: imageCount,
                imageSrc: introImage.filename,
                alt: introImage.alt ?? "",
                video: video
            })
        ]
    });
